// extracted by mini-css-extract-plugin
module.exports = {"userAvatarMain":"UserAvatar-module__userAvatarMain___1hNF2"};